/**
 * Procurement Management Services Module
 * Exports all procurement-related services and factory functions
 */
// Service exports
export * from './PurchaseRequestService';
export * from './QuotationService';
export * from './InvoiceService';
export * from './RequestAttachmentService';
export * from './RequestCommentService';
export * from './RequestTypeService';
export * from './RequestStatusService';
export * from './RequestStageService';
export * from './QuotationStatusService';
export * from './InvoiceStatusService';
export * from './ProcurementRoleTypeService';
export * from './NotificationService';
export * from './AuditLogService';
export * from './QuotationLineService';
export * from './InvoiceLineService';
export * from './RequestApprovalStatusService';
export * from './CurrencyService';
export * from './QuotationLineApprovalService';
export * from './StaffRequestPortalService';
export * from './ApproverPortalService';
export * from './FinancePortalService';
export * from './ProcurementDashboardService';
export * from './ProcurementRoleAssignmentService';
export * from './RequestApprovalService';
export * from './RequestPurchaseOrderService';
export * from './ProcurementItemService';
export * from './ItemCategoryService';
export * from './ApprovalPortalService';
export * from './ApprovalLevelService';
export * from './QuotationLineApprovalStatusService';
export * from './ProcurementSettingService';
// Service imports for factory
import { PurchaseRequestService } from './PurchaseRequestService';
import { QuotationService } from './QuotationService';
import { InvoiceService } from './InvoiceService';
import { RequestAttachmentService } from './RequestAttachmentService';
import { RequestCommentService } from './RequestCommentService';
import { RequestTypeService } from './RequestTypeService';
import { RequestStatusService } from './RequestStatusService';
import { RequestStageService } from './RequestStageService';
import { QuotationStatusService } from './QuotationStatusService';
import { InvoiceStatusService } from './InvoiceStatusService';
import { ProcurementRoleTypeService } from './ProcurementRoleTypeService';
import { NotificationService } from './NotificationService';
import { AuditLogService } from './AuditLogService';
import { QuotationLineService } from './QuotationLineService';
import { InvoiceLineService } from './InvoiceLineService';
import { RequestApprovalStatusService } from './RequestApprovalStatusService';
import { CurrencyService } from './CurrencyService';
import { QuotationLineApprovalService } from './QuotationLineApprovalService';
import { StaffRequestPortalService } from './StaffRequestPortalService';
import { ApproverPortalService } from './ApproverPortalService';
import { FinancePortalService } from './FinancePortalService';
import { ProcurementDashboardService } from './ProcurementDashboardService';
import { ProcurementRoleAssignmentService } from './ProcurementRoleAssignmentService';
import { RequestApprovalService } from './RequestApprovalService';
import { RequestPurchaseOrderService } from './RequestPurchaseOrderService';
import { ProcurementItemService } from './ProcurementItemService';
import { ItemCategoryService } from './ItemCategoryService';
import { ApprovalPortalService } from './ApprovalPortalService';
import { ApprovalLevelService } from './ApprovalLevelService';
import { QuotationLineApprovalStatusService } from './QuotationLineApprovalStatusService';
import { ProcurementSettingService } from './ProcurementSettingService';
/**
 * Create all procurement services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all procurement service instances
 */
export function createProcurementsServices(http, config) {
    return {
        purchaseRequest: new PurchaseRequestService(http, config),
        quotation: new QuotationService(http, config),
        invoice: new InvoiceService(http, config),
        requestAttachment: new RequestAttachmentService(http, config),
        requestComment: new RequestCommentService(http, config),
        requestType: new RequestTypeService(http, config),
        requestStatus: new RequestStatusService(http, config),
        requestStage: new RequestStageService(http, config),
        quotationStatus: new QuotationStatusService(http, config),
        invoiceStatus: new InvoiceStatusService(http, config),
        procurementRoleType: new ProcurementRoleTypeService(http, config),
        notification: new NotificationService(http, config),
        auditLog: new AuditLogService(http, config),
        quotationLine: new QuotationLineService(http, config),
        invoiceLine: new InvoiceLineService(http, config),
        requestApprovalStatus: new RequestApprovalStatusService(http, config),
        currency: new CurrencyService(http, config),
        quotationLineApproval: new QuotationLineApprovalService(http, config),
        staffRequestPortal: new StaffRequestPortalService(http, config),
        approverPortal: new ApproverPortalService(http, config),
        financePortal: new FinancePortalService(http, config),
        procurementDashboard: new ProcurementDashboardService(http, config),
        procurementRoleAssignment: new ProcurementRoleAssignmentService(http, config),
        requestApproval: new RequestApprovalService(http, config),
        requestPurchaseOrder: new RequestPurchaseOrderService(http, config),
        procurementItem: new ProcurementItemService(http, config),
        itemCategory: new ItemCategoryService(http, config),
        approvalPortal: new ApprovalPortalService(http, config),
        approvalLevel: new ApprovalLevelService(http, config),
        quotationLineApprovalStatus: new QuotationLineApprovalStatusService(http, config),
        procurementSetting: new ProcurementSettingService(http, config),
    };
}
//# sourceMappingURL=index.js.map